import React from 'react';
import { OFFER, BRAND } from '../lib/content';
import { Reveal } from './Reveal';
import { Button } from './ui/Button';
export function FinalOffer() {
  return <section className="w-full bg-navy-50/30 py-20 sm:py-28" data-id="element-125" data-mp="12iz0lpdefz8x">
      <div className="mx-auto w-full max-w-4xl px-5 sm:px-8" data-id="element-126" data-mp="1gh6qxefxk2b4">
        <Reveal className="text-center" data-id="element-127" data-mp="1cf24aznwg5xz">
          <span className="inline-flex items-center gap-2 rounded-full bg-orange px-4 py-2 font-display text-xs font-extrabold uppercase tracking-[0.14em] text-white shadow-sm" data-id="element-128" data-mp="1cd8sz72ccxjn">
            🔥 ÚLTIMA OFERTA DE LA PÁGINA
          </span>
          <h2 className="mt-6 text-4xl font-black leading-tight text-navy sm:text-6xl font-[Barlow,_sans-serif]" data-id="element-129" data-mp="1ldnot0cxlv1e">
            Hoy puede empezar
            <br data-id="element-130" data-mp="1v6crb5qi7ykl" />
            <span className="text-orange" data-id="element-131" data-mp="1v5th6b73ieh4">a crear de verdad.</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-lg font-medium text-navy/70" data-id="element-132" data-mp="29649zjryu34x">
            Llevate hoy el acceso completo a Mini Constructores para que tu hijo cree, juegue y aprenda desde casa.
          </p>
        </Reveal>

        <Reveal className="mt-12" delay={0.1} float={true} data-id="element-133" data-mp="1r9uf5r0d9e1">
          <div className="mx-auto max-w-3xl overflow-hidden rounded-[2rem] shadow-2xl sm:rounded-[2.5rem]" data-id="element-134" data-mp="6nqlo8ti83vc">
            <img src="https://cdn.magicpatterns.com/uploads/bGF98sLMafHvjpuYsKL6fc/ChatGPT_Image_28_jul_2026,_13_20_23.png" alt="Todo lo que incluye Mini Constructores" className="w-full object-cover" data-id="element-135" data-mp="bmlem3l6r8t6" />
          </div>
        </Reveal>

        <Reveal className="mt-8" delay={0.2} data-id="element-136" data-mp="pmmf3hxjge84">
          <div className="overflow-hidden rounded-[2.5rem] border-4 border-orange-100 bg-white shadow-card" data-id="element-137" data-mp="plb7t84vwoc9">
            <div className="bg-orange-50/50 px-6 py-8 text-center sm:px-12 sm:py-10" data-id="element-138" data-mp="uggui964271e">
              <h3 className="font-display text-xl font-black uppercase tracking-wide text-navy sm:text-2xl" data-id="element-139" data-mp="zfa5nuxxdlye">
                Todo esto recibís hoy:
              </h3>
            </div>
            
            <div className="px-6 py-8 sm:px-12 sm:py-10" data-id="element-140" data-mp="18bsyz8a2jbvi">
              <ul className="grid gap-4 sm:grid-cols-2 sm:gap-x-8 sm:gap-y-5" data-id="element-141" data-mp="35fl11jeqznq2">
                <li className="flex items-start gap-2 font-display text-[15px] font-bold text-navy" data-id="element-142" data-mp="30fylv4fczxem">✔ 🤖 Mini Constructores completo</li>
                <li className="flex items-start gap-2 font-display text-[15px] font-bold text-navy" data-id="element-143" data-mp="3e8ejfpphr385">✔ 🧩 +150 proyectos</li>
                <li className="flex items-start gap-2 font-display text-[15px] font-bold text-navy" data-id="element-144" data-mp="39e0k5c7pkby7">✔ 🎥 Proyectos en video</li>
                <li className="flex items-start gap-2 font-display text-[15px] font-bold text-navy" data-id="element-145" data-mp="3j66jj70ahvnf">✔ 🖨️ Plantillas imprimibles</li>
                <li className="flex items-start gap-2 font-display text-[15px] font-bold text-orange" data-id="element-146" data-mp="z0cq4zt622g">✔ 🎁 14 bonos incluidos</li>
                <li className="flex items-start gap-2 font-display text-[15px] font-bold text-navy" data-id="element-147" data-mp="3t1zvao66pl45">✔ ⚡ Acceso inmediato</li>
                <li className="flex items-start gap-2 font-display text-[15px] font-bold text-navy" data-id="element-148" data-mp="1yq31iok9s35x">✔ ♾️ Acceso de por vida</li>
                <li className="flex items-start gap-2 font-display text-[15px] font-bold text-navy" data-id="element-149" data-mp="1olwcfkznsx8v">✔ 🏠 Materiales simples de casa</li>
              </ul>

              <div className="mt-10 flex flex-col items-center border-t border-navy-50 pt-10 text-center" data-id="element-150" data-mp="1spkks5w47wv6">
                <div className="flex items-center gap-4" data-id="element-151" data-mp="1jvfy7yo0l7lg">
                  <span className="font-display text-xl font-bold text-navy/40 line-through" data-id="element-152" data-mp="1jtv3a7xsfmn2">
                    Antes: {BRAND.compareAtPrice}
                  </span>
                  <span className="rounded-full bg-grass-50 px-3 py-1 font-display text-xs font-extrabold uppercase tracking-wider text-[#3D9E40]" data-id="element-153" data-mp="19xibxgpptkvh">
                    Hoy
                  </span>
                </div>
                <div className="mt-2 font-display text-6xl font-black text-navy sm:text-[5rem]" data-id="element-154" data-mp="10xd3d38scgfq">
                  {BRAND.price}
                </div>
                <div className="mt-3 inline-flex items-center gap-2 rounded-full bg-sky-50 px-4 py-2 font-display text-sm font-bold text-sky" data-id="element-155" data-mp="2val235zvtc6n">
                  o {BRAND.installments}
                </div>

                <Button className="mt-8 w-full max-w-md py-5 text-lg sm:text-xl" data-id="element-156" data-mp="q9id1li0half">
                  {BRAND.ctaLabelAlt}
                </Button>

                <p className="mt-4 text-sm font-medium text-navy/60" data-id="element-157" data-mp="l8um0zts8tr7">
                  Recibís el acceso completo en tu email inmediatamente después de la compra.
                </p>
                <div className="mt-6 flex items-center gap-2 rounded-xl bg-grass-50 px-4 py-3 text-sm font-bold text-[#3D9E40]" data-id="element-158" data-mp="caj03b3v2k53">
                  {OFFER.secure}
                </div>
                <p className="mt-4 text-xs font-bold uppercase tracking-widest text-orange" data-id="element-159" data-mp="2j4v4nt54s4k">
                  ⚠️ Precio promocional disponible solamente por hoy.
                </p>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}